import { SxProps } from '@mui/material'
import StylesExtraInfoGuestServiceInterface
  from '~/src/pages/extra-info/guest/styles/StylesExtraInfoGuestServiceInterface'
import TemplateServiceStyleBase from '~/src/utils/template/TemplateServiceStyleBase'

export default class StylesExtraInfoGuestServiceStyleTwo extends TemplateServiceStyleBase implements StylesExtraInfoGuestServiceInterface {
  public getPageSx(): SxProps {
    return {
      my: 4,
      width: '40%',
      [this.muiTheme.breakpoints.only('xs')]: {
        width: '90%'
      },
      [this.muiTheme.breakpoints.only('sm')]: {
        width: '80%'
      },
      [this.muiTheme.breakpoints.only('md')]: {
        width: '65%'
      }
    }
  }
}
